import React from 'react';
import work from './Assets/images/work.svg';
import WorkTech from './WorkTech';

function Work() {
  return (
    <div className="work-content">
      <div className="image-content">
        <img className="responsive-img" src={work} alt="" />
      </div>
      <span className="recent-work"> Recent Work</span>
      <span className="applications"> Applications</span>

      <div className="work-section">
        <div className="work-title">Jellyfish</div>
        <WorkTech title={'Technology'}>
           React, React Hooks, TypeScript, Reactstrap
        </WorkTech>
        <WorkTech title={'Description'}>
          {' '}
          E-Commerce website and mobile app, which mainly features Ordering,
          Invoicing, Payments, and DSD app for Suppliers & Sales Reps
        </WorkTech>
      </div>
      <div className="work-section">
        <div className="work-title">CWDS Design System</div>
        <WorkTech title={'Technology'}>
          React, Redux, Typescript, Reactstrap, Formik, Netlify
        </WorkTech>
        <WorkTech title={'Description'}>
          A Component Library built from scratch for Child Welfare Digital
          Services devs.
        </WorkTech>
      </div>
      <div className="work-section">
        <div className="work-title">City Nexus</div>
        <WorkTech title={'Technology'}>
          Html5, SCSS, Javascript, Jquery
        </WorkTech>
        <WorkTech title={'Description'}>
          A redesign of City Of Sacramento Intranet system
        </WorkTech>
      </div>

      <span className="recent-work"> Personal Projects</span>
      <span className="applications"> Fun Weekend Projects</span>

      <div className="work-section">
        <div className="work-title">Timbre</div>
        <WorkTech title={'Technology'}>
          React
        </WorkTech>
        <WorkTech title={'Description'}>
          Timbre is a minimalistic Music App with lo-fi beats, thats proven to better your mood.
        </WorkTech>
        <span>
          <a target='_blank' href='https://timbre.netlify.app/'>Check it Out </a>
        </span>
      </div>

       <div className="work-section">
        <div className="work-title">React Drive Thru</div>
        <WorkTech title={'Technology'}>
          React, React Hooks
        </WorkTech>
        <WorkTech title={'Description'}>
          React Drive Thru - One stop destination for all the hooks.
        </WorkTech>
        <span>
          <a target='_blank' href='https://react-ykwcgx.stackblitz.io/'>Check it Out </a>
        </span>
      </div>

    </div>
  );
}

export default Work;
